import { ref } from 'vue'
import { axiosInstance } from '@/http-common'

// null = not yet checked; singleton shared across the app
const hasWirepas = ref<boolean | null>(null)
let fetchPromise: Promise<boolean> | null = null

export async function fetchWirepasStatus(): Promise<boolean> {
  if (fetchPromise) return fetchPromise
  fetchPromise = axiosInstance
    .get('/api/v1/wirepas-assets/stats')
    .then(res => {
      hasWirepas.value = (res.data?.total ?? 0) > 0
      return hasWirepas.value
    })
    .catch(() => {
      hasWirepas.value = false
      return false
    })
  return fetchPromise
}

export function resetWirepasStatus(): void {
  hasWirepas.value = null
  fetchPromise = null
}

export { hasWirepas }
